import React from "react";
import RegisterPage, { STATUS_BADGES, StatCard } from "../components/RegisterPage";
import { useHSE } from "../lib/store";
import { apiFetch } from "../lib/api";

export default function ManagementOfChange() {
  const { data, siteNames } = useHSE();
  const rows = data.managementOfChange || data.moc || [];

  const handleSaveRecord = async (editingRecord) => {
    try {
      const res = await apiFetch("/moc", {
        method: "POST",
        body: {
          ...editingRecord,
          idempotencyKey: `moc-${editingRecord.id}`,
        },
      });
      return res?.item ? { ...editingRecord, ...res.item } : editingRecord;
    } catch (err) {
      return editingRecord;
    }
  };

  const Top = (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
      <StatCard label="Total MOC Requests" value={rows.length} testid="moc-total" />
      <StatCard label="Permanent" value={rows.filter((r) => r.changeType === "permanent").length} tone="info" />
      <StatCard label="Temporary" value={rows.filter((r) => r.changeType === "temporary").length} tone="warning" />
      <StatCard label="Approved / Active" value={rows.filter((r) => r.status === "approved" || r.status === "implemented").length} tone="safe" />
      <StatCard label="Under Review" value={rows.filter((r) => r.status === "submitted" || r.status === "reviewed").length} tone="info" />
    </div>
  );

  return (
    <RegisterPage
      title="Management of Change (MOC)"
      subtitle="ISO 45001 Clause 8.1.3 — Governed Temporary, Permanent & Emergency Change Control & Impact Evaluation"
      storeKey="managementOfChange"
      idPrefix="MOC"
      topPanels={Top}
      onSaveRecord={handleSaveRecord}
      columns={[
        { key: "id", label: "MOC ID" },
        { key: "changeType", label: "Change Type", render: (r) => <span className={`uppercase text-[10px] font-bold px-2 py-0.5 rounded ${r.changeType === "emergency" ? "bg-rose-100 text-rose-800" : r.changeType === "temporary" ? "bg-amber-100 text-amber-800" : "bg-blue-100 text-blue-800"}`}>{r.changeType || "permanent"}</span> },
        { key: "title", label: "Change Title" },
        { key: "requestedByUserId", label: "Requested By" },
        { key: "effectiveDate", label: "Effective Date" },
        { key: "expiryDate", label: "Expiry Date", render: (r) => r.expiryDate || "N/A (Permanent)" },
        { key: "status", label: "Status" },
      ]}
      badgeMap={{ status: STATUS_BADGES }}
      formFields={[
        { key: "id", label: "MOC ID" },
        { key: "site", label: "Site", type: "select", options: siteNames },
        { key: "changeType", label: "Change Type", type: "select", options: ["temporary", "permanent", "emergency"] },
        { key: "title", label: "Change Title" },
        { key: "justification", label: "Justification for Change", type: "textarea", full: true },
        { key: "hseImpact", label: "HSE Risk & Impact Evaluation", type: "textarea", full: true },
        { key: "environmentalImpact", label: "Environmental Impact", type: "textarea", full: true },
        { key: "legalImpact", label: "Legal & Regulatory Impact", type: "textarea", full: true },
        { key: "riskAssessmentId", label: "Linked Risk Assessment (RA)" },
        { key: "methodStatementId", label: "Linked Method Statement (MS)" },
        { key: "requestedByUserId", label: "Requested By User ID" },
        { key: "preStartConditions", label: "Pre-Start & Verification Conditions", type: "textarea", full: true },
        { key: "trainingRequired", label: "Worker Training Required?", type: "select", options: [false, true] },
        { key: "effectiveDate", label: "Effective Date", type: "date" },
        { key: "expiryDate", label: "Expiry Date (Temporary)", type: "date" },
        { key: "status", label: "Status", type: "select", options: ["draft", "submitted", "reviewed", "approved", "implemented", "closed", "rejected"] },
      ]}
    />
  );
}
